import {
  APPROVE_TEAM,
  APPROVE_TEAM_ERROR,
  APPROVE_TEAM_SUCCESS,
  COMPANY_DETAIL,
  COMPANY_DETAIL_ERROR,
  COMPANY_DETAIL_SUCCESS,
  CREATE_TEAM,
  CREATE_TEAM_ERROR,
  CREATE_TEAM_LOOKUP,
  CREATE_TEAM_LOOKUP_ERROR,
  CREATE_TEAM_LOOKUP_SUCCESS,
  CREATE_TEAM_SUCCESS,
  END_TEAM,
  END_TEAM_ERROR,
  END_TEAM_SUCCESS,
  GET_CATEGORY_USER,
  GET_CATEGORY_USER_ERROR,
  GET_CATEGORY_USER_SUCCESS,
  GET_COMPANY_DETAIL,
  GET_COMPANY_DETAIL_ERROR,
  GET_COMPANY_DETAIL_SUCCESS,
  GET_PROJECT_TEAMS,
  GET_PROJECT_TEAMS_ERROR,
  GET_PROJECT_TEAMS_SUCCESS,
  GET_TEAMS,
  GET_TEAMS_ERROR,
  GET_TEAMS_SUCCESS,
  REJECT_TEAM,
  REJECT_TEAM_ERROR,
  REJECT_TEAM_SUCCESS,
  UPDATE_TEAMS,
  UPDATE_TEAMS_ERROR,
  UPDATE_TEAMS_NO_APPROVED,
  UPDATE_TEAMS_NO_APPROVED_ERROR,
  UPDATE_TEAMS_NO_APPROVED_SUCCESS,
  UPDATE_TEAMS_SUCCESS,
  UPLOAD_APPLICATION,
  UPLOAD_APPLICATION_ERROR,
  UPLOAD_APPLICATION_SUCCESS,
} from "./actionType"

export const getTeamLookup = () => {
  return {
    type: CREATE_TEAM_LOOKUP,
  }
}

export const getTeamLookupSuccess = category => {
  return {
    type: CREATE_TEAM_LOOKUP_SUCCESS,
    payload: category,
  }
}

export const getTeamLookupError = data => {
  return {
    type: CREATE_TEAM_LOOKUP_ERROR,
    payload: data,
  }
}
export const createTeam = (data, callback) => {
  return {
    type: CREATE_TEAM,
    payload: data,
    callback,
  }
}

export const createTeamSuccess = category => {
  return {
    type: CREATE_TEAM_SUCCESS,
    payload: category,
  }
}

export const createTeamError = data => {
  return {
    type: CREATE_TEAM_ERROR,
    payload: data,
  }
}

export const getTeams = data => {
  return {
    type: GET_TEAMS,
    payload: data,
  }
}

export const getTeamsSuccess = category => {
  return {
    type: GET_TEAMS_SUCCESS,
    payload: category,
  }
}

export const getTeamsError = data => {
  return {
    type: GET_TEAMS_ERROR,
    payload: data,
  }
}
export const approveTeam = data => {
  return {
    type: APPROVE_TEAM,
    payload: data,
  }
}
export const approveTeamSuccess = data => {
  return {
    type: APPROVE_TEAM_SUCCESS,
    payload: data,
  }
}

export const approveTeamError = data => {
  return {
    type: APPROVE_TEAM_ERROR,
    payload: data,
  }
}
//reject team api
export const rejectTeam = data => {
  return {
    type: REJECT_TEAM,
    payload: data,
  }
}
export const rejectTeamSuccess = data => {
  return {
    type: REJECT_TEAM_SUCCESS,
    payload: data,
  }
}

export const rejectTeamError = data => {
  return {
    type: REJECT_TEAM_ERROR,
    payload: data,
  }
}
//end reject

export const endTeam = data => {
  return {
    type: END_TEAM,
    payload: data,
  }
}
export const endTeamSuccess = data => {
  return {
    type: END_TEAM_SUCCESS,
    payload: data,
  }
}

export const endTeamError = data => {
  return {
    type: END_TEAM_ERROR,
    payload: data,
  }
}

// update Team
export const onUpdateTeams = (teams, callback) => {
  return {
    type: UPDATE_TEAMS,
    payload: teams,
    callback,
  }
}

export const updateteamsSuccess = teams => {
  return {
    type: UPDATE_TEAMS_SUCCESS,
    payload: teams,
  }
}

export const updateteamsFail = error => {
  return {
    type: UPDATE_TEAMS_ERROR,
    payload: error,
  }
}
export const getCompanyDetails = id => {
  return {
    type: GET_COMPANY_DETAIL,
    payload: id,
  }
}

export const getCompanyDetailsSuccess = data => {
  return {
    type: GET_COMPANY_DETAIL_SUCCESS,
    payload: data,
  }
}

export const getCompanyDetailsError = error => {
  return {
    type: GET_COMPANY_DETAIL_ERROR,
    payload: error,
  }
}
export const activitysummary = data => {
  return {
    type: COMPANY_DETAIL,
    payload: data,
  }
}

export const activitysummarySuccess = data => {
  return {
    type: COMPANY_DETAIL_SUCCESS,
    payload: data,
  }
}

export const activitysummaryError = error => {
  return {
    type: COMPANY_DETAIL_ERROR,
    payload: error,
  }
}
//project base team view
export const getProjectTeams = data => {
  return {
    type: GET_PROJECT_TEAMS,
    payload: data,
  }
}
export const getProjectTeamsSuccess = category => {
  return {
    type: GET_PROJECT_TEAMS_SUCCESS,
    payload: category,
  }
}

export const getProjectTeamsError = data => {
  return {
    type: GET_PROJECT_TEAMS_ERROR,
    payload: data,
  }
}
// edit team wasn't approved
export const onUpdateTeamsNoApproved = (teams, callback) => {
  return {
    type: UPDATE_TEAMS_NO_APPROVED,
    payload: teams,
    callback,
  }
}

export const updateteamsSuccessNoApproved = teams => {
  return {
    type: UPDATE_TEAMS_NO_APPROVED_SUCCESS,
    payload: teams,
  }
}

export const updateteamsFailNoApproved = error => {
  return {
    type: UPDATE_TEAMS_NO_APPROVED_ERROR,
    payload: error,
  }
}

// edit team wasn't approved
export const onUploadapplication = (apps, callback) => {
  return {
    type: UPLOAD_APPLICATION,
    payload: apps,
    callback,
  }
}

export const uploadapplicationsuccess = apps => {
  return {
    type: UPLOAD_APPLICATION_SUCCESS,
    payload: apps,
  }
}

export const uploadapplicationerror = error => {
  return {
    type: UPLOAD_APPLICATION_ERROR,
    payload: error,
  }
}

export const getCategoryUser = data =>{
  return{
    type: GET_CATEGORY_USER,
    payload: data
  }
}

export const getCategoryUserSuccess = data => {
  return {
    type: GET_CATEGORY_USER_SUCCESS,
    payload: data,
  }
}

export const getCategoryUserError = data => {
  return {
    type: GET_CATEGORY_USER_ERROR,
    payload: data,
  }
}